import {FC} from 'react'
import {OverlayTrigger, Popover} from 'react-bootstrap'

type Props = {
  // Explica o PORQUÊ do campo, não repete o rótulo.
  text: string
  // Link opcional "Saiba mais" (post da Central de ajuda).
  href?: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

// Padrão único de tooltip de ajuda: ícone de informação que abre uma dica curta, acessível por
// mouse, foco e teclado (o balão permanece aberto para dar tempo de clicar em "Saiba mais").
export const HelpTip: FC<Props> = ({text, href, placement = 'top'}) => (
  <OverlayTrigger
    placement={placement}
    trigger={['hover', 'focus']}
    delay={{show: 100, hide: 350}}
    overlay={
      <Popover className='help-tip-popover'>
        <Popover.Body>
          <span>{text}</span>
          {href && (
            <a href={href} target='_blank' rel='noreferrer' className='help-tip-link'>
              Saiba mais
            </a>
          )}
        </Popover.Body>
      </Popover>
    }
  >
    <button type='button' className='help-tip-btn' aria-label='Ajuda sobre este campo'>
      <i className='bi bi-info-circle'></i>
    </button>
  </OverlayTrigger>
)
